import { createReducer, on } from '@ngrx/store';

import {
	fetchTaskFail,
	fetchTaskSuccess,
	initTaskList,
	updateViewActiveJobs,
} from './task.actions';
import { TaskSliceState } from './task.state';

export const taskReducer = createReducer<TaskSliceState>(
	new TaskSliceState(),
	on(initTaskList, (state) => state.setLoading(true)),
	on(fetchTaskSuccess, (state, action) =>
		state.setLoading(false).setTaskList(action.taskList)
	),
	on(fetchTaskFail, (state) => state.setLoading(false)),
	on(updateViewActiveJobs, (state, action) =>
		state.setLoading(true).setViewActiveJobs(action.activeJobs)
	)
);
